export default __webpack_public_path__ + "static/media/image-4.004ed8ca.jpg";